import Swiper, { Navigation, Autoplay, Mousewheel } from "swiper";
import "swiper/swiper.min.css";
import "swiper/css/navigation";

export default class testimonialSwiper {
  constructor(el) {
    this.el = el;
    this.slider = null;
    this.init();
  }

  init() {
    this.slider = new Swiper(this.el, {
      slidesPerView: "1",
      spaceBetween: 30,
      autoplay: {
        delay: 3000,
      },
      modules: [Navigation, Mousewheel],
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      mousewheel: {
        releaseOnEdges: true,
      },
      grabCursor: true,
      breakpoints: {
        768: {
          slidesPerView: "2",
          autoplay: false,
        },
        992: {
          slidesPerView: "3",
        }
      },
    });
  }
}
